/**
 * useWishlists Hook
 * Manages user's wishlists with real-time updates
 */

import { useEffect, useState } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { Wishlist } from '@/types'
import { subscribeToUserWishlists } from '@/services/wishlist.service'

export function useWishlists() {
  const { user } = useAuth()
  const [wishlists, setWishlists] = useState<Wishlist[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!user) {
      setWishlists([])
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    const unsubscribe = subscribeToUserWishlists(
      user.uid,
      wishlists => {
        setWishlists(wishlists)
        setLoading(false)
      }
    )

    return () => unsubscribe()
  }, [user])

  return {
    wishlists,
    loading,
    error,
  }
}
